import script from "./accuFundView.vue?vue&type=script&setup=true&lang=ts"
export * from "./accuFundView.vue?vue&type=script&setup=true&lang=ts"

import "./accuFundView.vue?vue&type=style&index=0&id=b024fcdc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b024fcdc"]])

export default __exports__